import { createSelector } from 'reselect';
import type { API_RESPONSE } from '@corefront/eva-fe-sdk';
import { SAVE_GAME_FOR_RECOMMENDATIONS } from '../../constants/gameRecommendations';
import type { Nullable } from '../../../types';

export interface GameRecommendationsState {
  gameDataForRecommendations: Nullable<API_RESPONSE.GameInfo[200]>['game'];
}
export const initialState: GameRecommendationsState = {
  gameDataForRecommendations: null,
};

const reducer = (
  state = initialState,
  {
    type,
    payload,
  }: { type: string; payload: Nullable<API_RESPONSE.GameInfo[200]>['game'] }
): GameRecommendationsState => {
  switch (type) {
    case SAVE_GAME_FOR_RECOMMENDATIONS:
      return { ...state, gameDataForRecommendations: payload };
    default:
      return state;
  }
};

export default reducer;

/**
 * SELECTOR
 */
export const gameRecommendationsSelector = (state) => {
  return state?.ui?.gameRecommendations || initialState;
};

export const gameForRecommendationsSelector = createSelector(
  gameRecommendationsSelector,
  (state) =>
    state?.gameDataForRecommendations ?? initialState.gameDataForRecommendations
);
